<template>
  <div id="EmptyContent" class="empty-container">
    <img :src="img" alt="" style="width: 90px; height: 90px" />
    <i class="ft-grey">{{ text }}</i>
  </div>
</template>

<script>
import DefaultEmptyImg from '@/assets/img/data_empty.png'
export default {
  name: 'EmptyContent',
  props: {
    img: {
      type: String,
      default: DefaultEmptyImg,
    },
    text: {
      type: String,
      default: '暂无内容',
    },
  },
}
</script>

<style lang="less" scoped>
.empty-container {
  text-align: center;
  padding: 50px 0 30px;
}
.ft-grey {
  display: block;
  color: #787880;
  font-style: normal;
  margin-top: 20px;
}
</style>
<style>
.el-table__empty-text {
  line-height: unset !important;
}
</style>
